import EndUsersAccountsTable from './tables';
import FusePageCarded from '@fuse/core/FusePageCarded';
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import reducer from '../store';
import withReducer from 'app/store/withReducer';
import AddServiceRequestFormDialog from './addServiceRequestDialog';
import { usePermission } from '@fuse/hooks';
import { openFormViewerDialog,closeFormViewerDialog } from '../store/formViewDialogReducer';
import { usePusher } from '@fuse/hooks';
import useCurrentUser from '@fuse/hooks/useCurrentUser';
import SaveReportDialog from '../../reports/components/saveReportDialog';

const useStyles = makeStyles({
	layoutRoot: {
		background:'#fcfcfc'
	},
	pullRight:{
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "flex-end"
	},
	buttonContainer:{
		display: 'flex',
		flexDirection: 'row'
	},
	buttonSquare:{
		borderRadius: '5px'
	},
	topBg:{
		background:'#fcfcfc'
	},
	contentWrapper : {
		marginBottom:'15px',
		borderRadius:'10px'
	}
});

function CardedFullWidth2TabbedSample(props) {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { hasPermission } = usePermission();
	const viewServiceRequestPermission = hasPermission('view-service_request')
	const createServiceRequestPermission = hasPermission('add-service_request')
	const updateServiceRequestPermission = hasPermission('update-service_request')
	const deleteServiceRequestPermission = hasPermission('delete-service_request')
	const {broadcastChannel} = usePusher()
	const new_incident_event = "permission_change"
	const NEW_TICKET_CREATED_FROM_AGENT = "new_service_request_created_from_agent"
	const NEW_MESSAGE_FROM_AGENT = 'service_req_chat_new_message_from_agent'
	const user = useCurrentUser();
	const [selectedTab, setSelectedTab] = useState(0);
	const openState = useSelector((state) => state.ServiceRequestsApp.formViewDialog)
	const serial_number = useSelector(({ServiceRequestsApp})=>ServiceRequestsApp.filterParamsReducer.serial_number)
	const getServiceRequest = () => {window.dispatchEvent(new Event('refreshServiceRequestList'))};

	useEffect(()=>{
		if(serial_number){
			dispatch(openFormViewerDialog())
		}

		//call on component unmount
		return(()=>{
			dispatch(closeFormViewerDialog())
		})
	},[]);

	useEffect(()=>{
		if(broadcastChannel/* && invoices.length*/){
			broadcastChannel.bind(new_incident_event, data => {
				if(data.user_companies_id === user.data.user_companies_id){
					location.reload();
				}
			})
			broadcastChannel.bind(NEW_TICKET_CREATED_FROM_AGENT, data => {
				if(data.user_id === user.data.id){
					getServiceRequest();
				}
			});

			broadcastChannel.bind(NEW_MESSAGE_FROM_AGENT, data => {
				if(user.data.all_roles.includes('super_user') || data.user_id === user.data.id){
					getServiceRequest();
				}
			});

			return () => {
				broadcastChannel.unbind(new_incident_event)
				broadcastChannel.unbind(NEW_TICKET_CREATED_FROM_AGENT)
				broadcastChannel.unbind(NEW_MESSAGE_FROM_AGENT)
			}
		}
	},[broadcastChannel])

	function handleAddTicketFormClose () {
		dispatch(closeFormViewerDialog())
	}

	return (
		<div>
			<SaveReportDialog tableName={"service request"}/>
		
			<FusePageCarded
				classes={{
					root: classes.layoutRoot,
					toolbar: 'p-0',
					topBg: classes.topBg,
					contentWrapper : classes.contentWrapper
				}}
				content={
					<>
						<div className={selectedTab !== 0 ? 'hidden' : ''}>
							<EndUsersAccountsTable
								tableName='serviceRequest'
								viewServiceRequestPermission = {viewServiceRequestPermission}
								createServiceRequestPermission = {createServiceRequestPermission}
								updateServiceRequestPermission = {updateServiceRequestPermission}
								deleteServiceRequestPermission = {deleteServiceRequestPermission}
							/>
							{openState.open && <AddServiceRequestFormDialog open={openState.open} close={handleAddTicketFormClose}/>}
						</div>
					</>
				}
				innerScroll
			/>
		</div>
	)
}

export default withReducer('ServiceRequestsApp', reducer)(CardedFullWidth2TabbedSample);
